import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import {
  AccordionExpandPosition,
  AccordionItem,
} from '../../../models/accordion.models';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgTemplateOutlet } from '@angular/common';
import { MenuItemComponent } from '../../molecules/accordion-menu/menu-item.component';

@Component({
  selector: 'ui-accordion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NzCollapseModule,
    NzIconModule,
    NgTemplateOutlet,
    MenuItemComponent,
  ],
  template: `
    <nz-collapse [nzExpandIconPosition]="expandIconPosition()">
      @for (panel of panels(); let panelIndex = $index; track panel.id) {
        <nz-collapse-panel
          #collapsePanel
          [nzHeader]="headerTemplate"
          [nzActive]="panel.active"
          [nzDisabled]="!panel?.items ? true : panel.disabled"
          [nzShowArrow]="panel?.items?.length"
          [nzExpandedIcon]="panel?.icon || expandedIcon"
        >
          <ng-template #headerTemplate>
            <ng-container
              *ngTemplateOutlet="
                panel.header;
                context: { $implicit: panel.context }
              "
            ></ng-container>
          </ng-template>

          @if (panel?.items?.length) {
            <div class="flex flex-col p-0">
              @for (
                subitem of panel.items;
                let subitemIndex = $index;
                track subitem.id
              ) {
                <ui-menu-item
                  [active]="subitem.active"
                  [header]="subitem.header"
                  [preheader]="subitem?.preheader"
                  [context]="subitem.context?.count"
                  (onClick)="emitSubitemClick(panelIndex, subitemIndex)"
                />
              }
            </div>
          }

          <ng-template #expandedIcon>
            <nz-icon
              nzType="caret-right"
              class="ant-collapse-arrow"
              [nzRotate]="collapsePanel.nzActive ? -90 : 90"
            />
          </ng-template>
        </nz-collapse-panel>
      }
    </nz-collapse>
  `,
  styles: `
    .ant-collapse-content .ant-collapse-content-box {
      padding: 0 !important;
    }
  `,
})
export class AccordionComponent {
  panels = input.required<AccordionItem[]>();
  expandIconPosition = input<AccordionExpandPosition>('start');
  onSubitemClick = output<{ panelIndex: number; subitemIndex: number }>();

  emitSubitemClick(panelIndex: number, subitemIndex: number) {
    this.onSubitemClick.emit({
      panelIndex,
      subitemIndex,
    });
  }
}
